module.exports = __webpack_public_path__ + "img/dc-electricity.792a97ac.svg";